import {ReactComponent as EnsoIcon} from "connectui/icons/enso-logo.svg";
import {ReactComponent as InboxIcon} from "connectui/icons/inbox.svg";
import {ReactComponent as ClockIcon} from "connectui/icons/clock.svg";
import {ReactComponent as CoinStackIcon} from "connectui/icons/coin-stack.svg";
import {ReactComponent as UserIcon} from "connectui/icons/user.svg";
import {ReactComponent as ZapIcon} from "connectui/icons/zap.svg";
import {ReactComponent as EditIcon} from "connectui/icons/edit.svg";
import {ReactComponent as MoreVerticalIcon} from "connectui/icons/more-vertical.svg";
import {ReactComponent as SettingsTuneIcon} from "connectui/icons/settings-tune.svg";
import {ReactComponent as EyeIcon} from "connectui/icons/eye.svg";
import {ReactComponent as EyeOffIcon} from "connectui/icons/eye-off.svg";
import {ReactComponent as CopyIcon} from "connectui/icons/copy.svg";
import {ReactComponent as TrashIcon} from "connectui/icons/trash.svg";
import {ReactComponent as HomeIcon} from "connectui/icons/home.svg";
import {ReactComponent as CloudRainIcon} from "connectui/icons/cloud-rain.svg";
import {ReactComponent as UnlockIcon} from "connectui/icons/unlock.svg";
import {ReactComponent as AnchorIcon} from "connectui/icons/anchor.svg";
import {ReactComponent as BatteryChargingIcon} from "connectui/icons/battery-charging.svg";
import {ReactComponent as WindIcon} from "connectui/icons/wind.svg";
import {ReactComponent as VolumeXIcon} from "connectui/icons/volume-x.svg";
import {ReactComponent as ThermometerIcon} from "connectui/icons/thermometer.svg";
import {ReactComponent as TruckIcon} from "connectui/icons/truck.svg";
import {ReactComponent as AtSignIcon} from "connectui/icons/at-sign.svg";
import {ReactComponent as ToolIcon} from "connectui/icons/tool.svg";
import {ReactComponent as BellIcon} from "connectui/icons/bell.svg";
import {ReactComponent as ThumbsUpIcon} from "connectui/icons/thumbs-up.svg";
import {ReactComponent as KidIcon} from "connectui/icons/kid.svg";
import {ReactComponent as CheckCircleIcon} from "connectui/icons/check-circle.svg";
import {ReactComponent as BoardingPassTicket} from "connectui/icons/boardingpass-ticket.svg";
import {ReactComponent as AlertTriangleIcon} from "connectui/icons/alert-triangle.svg";
import {ReactComponent as LayoutSidebarRightIcon} from "connectui/icons/layout-sidebar-right.svg";
import {ReactComponent as LayoutSidebarLeftIcon} from "connectui/icons/layout-sidebar-left.svg";
import {ReactComponent as CheckIcon} from "connectui/icons/check.svg";
import {ReactComponent as XIcon} from "connectui/icons/x.svg";
import {ReactComponent as SmallXIcon} from "connectui/icons/small-x.svg";
import {ReactComponent as MenuIcon} from "connectui/icons/menu.svg";
import {ReactComponent as HourglassIcon} from "connectui/icons/hourglass.svg";
import {ReactComponent as HomeOwnerIcon} from "connectui/icons/home-owner.svg";
import {ReactComponent as HelpCircleIcon} from "connectui/icons/help-circle.svg";
import {ReactComponent as CheckInIcon} from "connectui/icons/check-in.svg";
import {ReactComponent as CheckOutIcon} from "connectui/icons/check-out.svg";
import {ReactComponent as CleanIcon} from "connectui/icons/clean.svg";
import {ReactComponent as PlusCircleIcon} from "connectui/icons/plus-circle.svg";
import {ReactComponent as ArrowLeftIcon} from "connectui/icons/arrow-left.svg";
import {ReactComponent as ChevronUpIcon} from "connectui/icons/chevron-up.svg";
import {ReactComponent as ChevronDownIcon} from "connectui/icons/chevron-down.svg";
import {ReactComponent as ChevronLeftIcon} from "connectui/icons/chevron-left.svg";
import {ReactComponent as ChevronRightIcon} from "connectui/icons/chevron-right.svg";
import {ReactComponent as DoubleArrowDownIcon} from "connectui/icons/double-arrow-down.svg";
import {ReactComponent as SearchIcon} from "connectui/icons/search.svg";
import {ReactComponent as FilterIcon} from "connectui/icons/filter.svg";
import {ReactComponent as ArchiveIcon} from "connectui/icons/archive.svg";
import {ReactComponent as NoMessagesIcon} from "connectui/icons/no-messages.svg";
import {ReactComponent as NoMessagesFiltersIcon} from "connectui/icons/no-messages-filters.svg";
import {ReactComponent as CircleIcon} from "connectui/icons/circle.svg";
import {ReactComponent as List} from "connectui/icons/list.svg";
import {ReactComponent as Key} from "connectui/icons/key.svg";
import {ReactComponent as DollarSignIcon} from "connectui/icons/dollar-sign.svg";
import {ReactComponent as FileTextIcon} from "connectui/icons/file-text.svg";
import {ReactComponent as IdCardIcon} from "connectui/icons/id-card.svg";
import {ReactComponent as TagIcon} from "connectui/icons/tag.svg";
import {ReactComponent as PhoneIcon} from "connectui/icons/phone.svg";
import {ReactComponent as GlobeIcon} from "connectui/icons/globe.svg";
import {ReactComponent as AIIcon} from "connectui/icons/ai.svg";
import {ReactComponent as SearchPeople} from "connectui/icons/search-people.svg";
import {ReactComponent as MessageCircleIcon} from "connectui/icons/message-circle.svg";
import {ReactComponent as MessageCircleFilledIcon} from "connectui/icons/message-circle-filled.svg";
import {ReactComponent as NoteIcon} from "connectui/icons/note.svg";
import {ReactComponent as PinIcon} from "connectui/icons/pin.svg";
import {ReactComponent as FileIcon} from "connectui/icons/file.svg";
import {ReactComponent as MailIcon} from "connectui/icons/mail.svg";
import {ReactComponent as AirbnbIcon} from "connectui/icons/airbnb.svg";
import {ReactComponent as VRBOIcon} from "connectui/icons/vrbo.svg";
import {ReactComponent as HomeAwayIcon} from "connectui/icons/homeaway.svg";
import {ReactComponent as BookingComIcon} from "connectui/icons/bookingcom.svg";
import {ReactComponent as ExpediaIcon} from "connectui/icons/expedia.svg";
import {ReactComponent as WhatsAppIcon} from "connectui/icons/whatsapp.svg";
import {ReactComponent as SendIcon} from "connectui/icons/send.svg";
import {ReactComponent as SendScheduledIcon} from "connectui/icons/send-scheduled.svg";
import {ReactComponent as SendAutopilotIcon} from "connectui/icons/send-autopilot.svg";
import {ReactComponent as DashSquareIcon} from "connectui/icons/dash-square.svg";
import {ReactComponent as PlusIcon} from "connectui/icons/plus.svg";
import {ReactComponent as CalendarIcon} from "connectui/icons/calendar.svg";
import {ReactComponent as MapPinIcon} from "connectui/icons/map-pin.svg";
import {ReactComponent as UsersIcon} from "connectui/icons/users.svg";
import {ReactComponent as UserPlusIcon} from "connectui/icons/user-plus.svg";
import {ReactComponent as InfoIcon} from "connectui/icons/info.svg";
import {ReactComponent as UnsatisfiedIcon} from "connectui/icons/unsatisfied.svg";
import {ReactComponent as SomewhatSatisfiedIcon} from "connectui/icons/somewhat-satisfied.svg";
import {ReactComponent as NeutralIcon} from "connectui/icons/neutral.svg";
import {ReactComponent as SatisfiedIcon} from "connectui/icons/satisfied.svg";
import {ReactComponent as HighlySatisfiedIcon} from "connectui/icons/highly-satisfied.svg";
import {ReactComponent as SmileIcon} from "connectui/icons/smile.svg";
import {ReactComponent as AlarmSnoozeIcon} from "connectui/icons/alarm-snooze.svg";
import {ReactComponent as UndoIcon} from "connectui/icons/undo.svg";
import {ReactComponent as ForwardIcon} from "connectui/icons/forward.svg";
import {ReactComponent as ImageIcon} from "connectui/icons/image.svg";
import {ReactComponent as FilmIcon} from "connectui/icons/film.svg";
import {ReactComponent as AlertCircleIcon} from "connectui/icons/alert-circle.svg";
import {ReactComponent as PhoneCardIcon} from "connectui/icons/phone-card.svg";
import {ReactComponent as EmailIcon} from "connectui/icons/email.svg";
import {ReactComponent as AirbnbCircleIcon} from "connectui/icons/airbnb-circle.svg";
import {ReactComponent as BookingComCircleIcon} from "connectui/icons/bookingcom-circle.svg";
import {ReactComponent as ExpediaCircleIcon} from "connectui/icons/expedia-circle.svg";
import {ReactComponent as VRBOCircleIcon} from "connectui/icons/vrbo-circle.svg";
import {ReactComponent as GoogleCircleIcon} from "connectui/icons/google-circle.svg";
import {ReactComponent as HomeAwayCircleIcon} from "connectui/icons/homeaway-circle.svg";
import {ReactComponent as WhatsAppCircleIcon} from "connectui/icons/whatsapp-circle.svg";
import {ReactComponent as TranslateIcon} from "connectui/icons/translate.svg";
import {ReactComponent as CornerUpLeftIcon} from "connectui/icons/corner-up-left.svg";
import {ReactComponent as FileImportIcon} from "connectui/icons/file-import.svg";
import {ReactComponent as MergeIcon} from "connectui/icons/merge.svg";
import {ReactComponent as DownloadIcon} from "connectui/icons/download.svg";
import {ReactComponent as ColumnsIcon} from "connectui/icons/columns.svg";
import {ReactComponent as CampaignIcon} from "connectui/icons/cmp.svg";
import {ReactComponent as DashboardBarIcon} from "connectui/icons/dashboard-bar.svg";
import {ReactComponent as InboxFilledIcon} from "connectui/icons/inbox-filled.svg";
import {ReactComponent as BriefcaseIcon} from "connectui/icons/briefcase.svg";
import {ReactComponent as BarChartIcon} from "connectui/icons/bar-chart.svg";
import {ReactComponent as MessagesIcon} from "connectui/icons/messages.svg";
import {ReactComponent as LogOutIcon} from "connectui/icons/log-out.svg";
import {ReactComponent as ArrowUpRight} from "connectui/icons/arrow-up-right.svg";
import {ReactComponent as NoProducts} from "connectui/icons/no-products.svg";
import {ReactComponent as NoProductsAlt} from "connectui/icons/no-products-alt.svg";
import {ReactComponent as NoMessagesWhite} from "connectui/icons/no-messages-white.svg";
import {ReactComponent as MissingCardsWhite} from "connectui/icons/missing-cards-white.svg";
import {ReactComponent as NoTickets} from "connectui/icons/no-tickets.svg";

const ICONS = {
  enso: EnsoIcon,
  inbox: InboxIcon,
  clock: ClockIcon,
  "coin-stack": CoinStackIcon,
  user: UserIcon,
  zap: ZapIcon,
  key: Key,
  edit: EditIcon,
  "more-vertical": MoreVerticalIcon,
  "settings-tune": SettingsTuneIcon,
  eye: EyeIcon,
  "eye-off": EyeOffIcon,
  copy: CopyIcon,
  list: List,
  trash: TrashIcon,
  home: HomeIcon,
  "cloud-rain": CloudRainIcon,
  unlock: UnlockIcon,
  anchor: AnchorIcon,
  "battery-charging": BatteryChargingIcon,
  wind: WindIcon,
  "volume-x": VolumeXIcon,
  thermometer: ThermometerIcon,
  truck: TruckIcon,
  "at-sign": AtSignIcon,
  tool: ToolIcon,
  bell: BellIcon,
  "thumbs-up": ThumbsUpIcon,
  kid: KidIcon,
  "file-import": FileImportIcon,
  "check-circle": CheckCircleIcon,
  "alert-triangle": AlertTriangleIcon,
  "layout-sidebar-right": LayoutSidebarRightIcon,
  "layout-sidebar-left": LayoutSidebarLeftIcon,
  check: CheckIcon,
  x: XIcon,
  "small-x": SmallXIcon,
  menu: MenuIcon,
  hourglass: HourglassIcon,
  "home-owner": HomeOwnerIcon,
  "help-circle": HelpCircleIcon,
  "check-in": CheckInIcon,
  "check-out": CheckOutIcon,
  clean: CleanIcon,
  "plus-circle": PlusCircleIcon,
  "arrow-left": ArrowLeftIcon,
  "chevron-up": ChevronUpIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "double-arrow-down": DoubleArrowDownIcon,
  "no-messages": NoMessagesIcon,
  "no-messages-filters": NoMessagesFiltersIcon,
  "boarding-pass-ticket": BoardingPassTicket,
  search: SearchIcon,
  filter: FilterIcon,
  archive: ArchiveIcon,
  circle: CircleIcon,
  "dollar-sign": DollarSignIcon,
  "id-card": IdCardIcon,
  "file-text": FileTextIcon,
  tag: TagIcon,
  phone: PhoneIcon,
  globe: GlobeIcon,
  ai: AIIcon,
  "search-people": SearchPeople,
  "message-circle": MessageCircleIcon,
  "message-circle-filled": MessageCircleFilledIcon,
  note: NoteIcon,
  pin: PinIcon,
  file: FileIcon,
  mail: MailIcon,
  airbnb: AirbnbIcon,
  homeaway: HomeAwayIcon,
  bookingcom: BookingComIcon,
  expedia: ExpediaIcon,
  whatsapp: WhatsAppIcon,
  vrbo: VRBOIcon,
  send: SendIcon,
  "send-scheduled": SendScheduledIcon,
  "send-autopilot": SendAutopilotIcon,
  "dash-square": DashSquareIcon,
  plus: PlusIcon,
  calendar: CalendarIcon,
  "map-pin": MapPinIcon,
  users: UsersIcon,
  "user-plus": UserPlusIcon,
  info: InfoIcon,
  unsatisfied: UnsatisfiedIcon,
  "somewhat-satisfied": SomewhatSatisfiedIcon,
  neutral: NeutralIcon,
  satisfied: SatisfiedIcon,
  "highly-satisfied": HighlySatisfiedIcon,
  smile: SmileIcon,
  "alarm-snooze": AlarmSnoozeIcon,
  undo: UndoIcon,
  forward: ForwardIcon,
  image: ImageIcon,
  film: FilmIcon,
  "alert-circle": AlertCircleIcon,
  "phone-card": PhoneCardIcon,
  email: EmailIcon,
  "airbnb-circle": AirbnbCircleIcon,
  "bookingcom-circle": BookingComCircleIcon,
  "expedia-circle": ExpediaCircleIcon,
  "vrbo-circle": VRBOCircleIcon,
  "google-circle": GoogleCircleIcon,
  "homeaway-circle": HomeAwayCircleIcon,
  "whatsapp-circle": WhatsAppCircleIcon,
  translate: TranslateIcon,
  "corner-up-left": CornerUpLeftIcon,
  download: DownloadIcon,
  columns: ColumnsIcon,
  campaign: CampaignIcon,
  "dashboard-bar": DashboardBarIcon,
  "inbox-filled": InboxFilledIcon,
  briefcase: BriefcaseIcon,
  "bar-chart": BarChartIcon,
  messages: MessagesIcon,
  logout: LogOutIcon,
  "arrow-up-right": ArrowUpRight,
  "no-products": NoProducts,
  "no-products-alt": NoProductsAlt,
  "no-messages-white": NoMessagesWhite,
  "missing-cards-white": MissingCardsWhite,
  "no-tickets": NoTickets,
  merge: MergeIcon,
};

export default ICONS;
